// Unsichtbarer Wächter im App-Rahmen (hängt in `RueckrufWaechter`, siehe `rueckruf.tsx`): spielt den Ton, wenn eine neue SMS für
// dich eingeht (S08). Der Server schickt `sms.received` nur an die Zuständigen (ohne Zuständigen an alle). Das Banner „Neue SMS“,
// die Desktop-Mitteilung und den Push aufs Handy liefert schon die Erinnerung (`ErinnerungBanner`,
// `services/aufgaben_erinnerung.py`); hier kommt nur der Ton dazu, nichts doppelt. Ein- und ausschalten: Einstellungen › SMS.
import { useEchtzeit } from "../../api/echtzeit";
import { tonSpielen } from "../../kommunikation/smsTon";

export function SmsWaechter() {
  useEchtzeit(["sms.received"], () => tonSpielen());
  return null;
}
